<!--
 * @Author: 陈远锋
 * @Date: 2022-03-05 08:47:12
 * @LastEditTime: 2022-06-27 14:41:18
 * @FilePath: \qyOut\src\pages\agentGoods\list.vue
 * @Description: Do not edit
-->
<template>
    <div>
        <router-link to="/pages/agent_goods_add" style="float:right;">
        添加分配
      </router-link>
        <Breadcrumb :style="{ margin: '20px 10px' }">
            <BreadcrumbItem>代理商商品管理</BreadcrumbItem>
            <BreadcrumbItem>代理商商品列表</BreadcrumbItem>
        </Breadcrumb>
        <loading :loading="loading" :error="error"></loading>
        
        <!-- 搜索区域 -->
        <div style="margin: 10px; padding: 10px; background: #f8f8f9; border-radius: 4px;">
            <Row :gutter="16">
                <Col span="6" style="display: flex;align-items: center">
                    <div style="width: 100px;">
                        <span style="font-weight: bold;">代理商：</span>
                    </div>
                    <Select 
                        v-model="selectCompanyId" 
                        filterable
                        clearable
                        placeholder="请输入或选择代理商"
                        @on-change="userOnChange"
                        style="width: 100%;"
                    >
                        <Option v-for="company in companies" 
                                :value="company.id" 
                                :key="company.id"
                                :label="company.company_name">
                            {{ company.company_name }}
                        </Option>
                    </Select>
                </Col>
                <Col span="6" style="display: flex;align-items: center">
                    <div style="width: 100px;">
                        <span style="font-weight: bold;">商品别名：</span>
                    </div>
                    <Select 
                        v-model="selectCategoryId" 
                        filterable
                        clearable
                        placeholder="请输入或选择商品别名"
                        @on-change="categoryOnChange"
                        style="width: 100%;"
                    >
                        <Option v-for="category in couponCategories" 
                                :value="category.category_id" 
                                :key="category.category_id"
                                :label="category.alias">
                            {{ category.alias }}
                        </Option>
                    </Select>
                </Col>
                <Col span="8" style="display: flex; align-items: flex-end;">
                    <Button 
                        type="primary" 
                        @click="searchData"
                        style="margin-right: 10px;"
                    >
                        搜索
                    </Button>
                    <Button 
                        @click="resetSearch"
                    >
                        重置
                    </Button>
                </Col>
            </Row>
        </div>
        
        <Table border stripe ref="selection" :columns="columns1" :data="filteredAgentGoods" v-if="filteredAgentGoods">
          <template slot-scope="{ row }" slot="title">
            {{ row.coupon_categories.title }}
          </template>
          <template slot-scope="{ row }" slot="alias">
            {{ row.coupon_categories.alias }}
          </template>
          <template slot-scope="{ row }" slot="face_value">
            {{ row.coupon_categories.face_value }}
          </template>
          <template slot-scope="{ row }" slot="category_desc">
            {{ row.coupon_categories.category_desc }}
          </template>
          <template slot-scope="{ row }" slot="biz_type_desc">
            {{ row.coupon_categories.biz_type_desc }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <Button 
                type="error" 
                size="small" 
                @click="handleDelete(row)"
                :loading="deleteLoading && deletingItemId === row.id"
            >
                删除
            </Button>
          </template>
        </Table>
        <!-- 分页组件 -->
        <Page 
            v-if="pages.total > 0"
            style="margin: 10px; text-align:center;" 
            @on-change="pageOnChange" 
            :total="pages.total" 
            :current="pages.current_page"
            :page-size="pages.per_page" 
            show-elevator 
            prev-text="上一页" 
            next-text="下一页" 
            show-total
        />
        <!-- 删除确认模态框 -->
        <Modal
            v-model="deleteModalVisible"
            title="确认删除"
            @on-ok="confirmDelete"
            @on-cancel="cancelDelete"
        >
            <p>确定要删除该商品分配吗？</p>
            <p v-if="currentDeleteItem" style="margin-top: 10px;">
                <strong>代理商：</strong>{{ currentDeleteItem.company_name || '未知' }}<br>
                <strong>商品：</strong>{{ currentDeleteItem.coupon_categories ? currentDeleteItem.coupon_categories.title : '未知' }}
            </p>
        </Modal>
    </div>
</template>
<script>
import loading from "../loading.vue";
export default {
    components: { loading },
    data () {
        return {
            loading: false,
            deleteLoading: false, // 删除按钮的loading状态
            agentGoods: [], // 原始数据
            filteredAgentGoods: [], // 过滤后的数据
            error: null,
            baseGoods: [],
            dis: false,
            companies: [],
            couponCategories: [],
            // 搜索条件
            selectCompanyId: null,
            selectCategoryId: null,
            // 删除相关
            deleteModalVisible: false,
            currentDeleteItem: null,
            deletingItemId: null,
            columns1: [
                {
                    title: "分类ID",
                    key: "category_id",
                    align: "center",
                    minWidth: 80,
                },
                { title: "库存", key: "qty", align: "center", minWidth: 60 },
                { title: "名称", slot: "title", align: "center", minWidth: 100 },
                { title: "别名", slot: "alias", align: "center", minWidth: 100 },
                {
                    title: "面额",
                    slot: "face_value",
                    align: "center",
                    minWidth: 80
                },
                {
                  title: "类型",
                  slot: "category_desc",
                  align: "center",
                  minWidth: 80
                },
                {
                    title: "使用类型",
                    slot: "biz_type_desc",
                    align: "center",
                    minWidth: 80
                },
                {
                    title: "操作",
                    slot: "action",
                    align: "center",
                    width: 100,
                    fixed: 'right'
                }
            ],
            // 分页信息
            pages: {
                total: 0,
                current_page: 1,
                per_page: "",
                last_page: 1
            },
        };
    },
    created () {
        console.log("created");
        this.fetchData();
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        $route: "fetchData",
    },
    methods: {
        fetchData(url = null) {
            this.error = null;
            this.loading = true;
            
            let params = {};
            if (this.selectCompanyId) {
                params.company_id = this.selectCompanyId;
            }
            if (this.selectCategoryId) {
                params.category_id = this.selectCategoryId;
            }
            
            const requestUrl = url || "agentGoods/list";
            
            Promise.all([
                this.axios.get("company?type=0"),
                this.axios.get(requestUrl, { params }),
                this.axios.get("couponCategories/totalList")
            ]).then(([companyRes, goodsRes, categoryRes]) => {
                this.companies = companyRes.data.companies || [];
                this.agentGoods = goodsRes.data.agent_goods || [];
                // 更新分页信息
                if (goodsRes.data.meta) {
                    this.pages = {
                        total: goodsRes.data.meta.total,
                        current_page: goodsRes.data.meta.current_page,
                        per_page: goodsRes.data.meta.per_page,
                        last_page: goodsRes.data.meta.last_page,
                        links: goodsRes.data.meta.links 
                    };
                }
                
                this.agentGoods.forEach(item => {
                    const company = this.companies.find(c => c.id === item.company_id);
                    if (company) {
                        item.company_name = company.company_name;
                    }
                });
                this.filteredAgentGoods = [...this.agentGoods];
                this.couponCategories = categoryRes.data.coupon_categories || [];
                
                this.loading = false;
            }).catch((error) => {
                this.error = error;
                this.loading = false;
            });
        },
        
        userOnChange: function (company_id) {
            this.selectCompanyId = company_id;
        },
        
        categoryOnChange: function (category_id) {
            this.selectCategoryId = category_id;
        },
        
        pageOnChange: function (page) {
            let params = {
                page: page
            };
            
            if (this.selectCompanyId) {
                params.company_id = this.selectCompanyId;
            }
            if (this.selectCategoryId) {
                params.category_id = this.selectCategoryId;
            }
            
            this.loading = true;
            this.axios.get("agentGoods/list", { params })
                .then((goodsRes) => {
                    this.agentGoods = goodsRes.data.agent_goods || [];
                    
                    if (goodsRes.data.meta) {
                        this.pages = {
                            total: goodsRes.data.meta.total,
                            current_page: goodsRes.data.meta.current_page,
                            per_page: goodsRes.data.meta.per_page,
                            last_page: goodsRes.data.meta.last_page,
                            links: goodsRes.data.meta.links
                        };
                    }
                    
                    this.agentGoods.forEach(item => {
                        const company = this.companies.find(c => c.id === item.company_id);
                        if (company) {
                            item.company_name = company.company_name;
                        }
                    });
                    
                    this.filteredAgentGoods = [...this.agentGoods];
                    this.loading = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.loading = false;
                });
        },
        
        // 搜索数据
        searchData() {
            // 重置到第一页
            this.pages.current_page = 1;
            this.fetchData();
        },
        
        // 重置搜索
        resetSearch() {
            this.selectCompanyId = null;
            this.selectCategoryId = null;
            this.pages.current_page = 1;
            this.fetchData();
        },
        
        // 删除
        handleDelete(row) {
            this.currentDeleteItem = row;
            this.deleteModalVisible = true;
        },
        
        // 确认删除
        confirmDelete() {
            if (!this.currentDeleteItem) return;
            
            this.deleteLoading = true;
            this.deletingItemId = this.currentDeleteItem.id;
            
            this.axios.get(`agentGoods/del/${this.currentDeleteItem.id}`)
                .then((res) => {
                    this.$Message.success('删除成功');
                    console.log(res);
                    
                    // 重新加载当前页数据
                    this.fetchData();
                    
                    this.deleteModalVisible = false;
                    this.currentDeleteItem = null;
                    this.deleteLoading = false;
                    this.deletingItemId = null;
                })
                .catch((error) => {
                    console.error('删除失败:', error);
                    this.$Message.error('删除失败，请重试');
                    this.deleteLoading = false;
                    this.deletingItemId = null;
                });
        },
        
        // 取消删除
        cancelDelete() {
            this.deleteModalVisible = false;
            this.currentDeleteItem = null;
        }
    },
};
</script>